export default "__VITE_ASSET__05e3795e__"